module.exports = __webpack_public_path__ + "static/media/gdg_logo.dffb3244.png";